import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import LozengeRadioButton from '@wix/da-ds/pkg/Lozenge/dsPresets/LozengeRadioButton';
import { changeAspectRatio } from '../../../../redux/form/actions';
import { getAspectRatio } from '../../../../redux/form/selectors';
import { ratios } from '../constants';
import LabelText from '../LabelText';
import PanelInputField from '../PanelInputField';
import s from './AspectRatioRadioField.scss';
const AspectRatioRadioField = ()=>{
    const { t } = useTranslation('dreamup');
    const groupLabelId = useUniqueId();
    const aspectRatio = useSelector(getAspectRatio);
    const dispatch = useDispatch();
    const handleChange = useCallback((e)=>{
        dispatch(changeAspectRatio(e.target.value));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(PanelInputField, {
        rootTag: "div",
        role: "radiogroup",
        "aria-labelledby": groupLabelId,
        label: /*#__PURE__*/ React.createElement(LabelText, {
            id: groupLabelId
        }, t('dreamup.header.settingsPanel.aspectRatio.label')),
        input: /*#__PURE__*/ React.createElement("div", {
            className: s['radio-buttons']
        }, ratios.map((ratio)=>/*#__PURE__*/ React.createElement("div", {
                key: ratio.value,
                className: s['radio-button']
            }, /*#__PURE__*/ React.createElement(LozengeRadioButton, {
                name: "aspectRatio",
                value: ratio.value,
                className: s['radio-button-component'],
                checked: ratio.value === aspectRatio,
                onChange: handleChange,
                selectedClassName: s['selected'],
                hasAccessibleText: true
            }, /*#__PURE__*/ React.createElement("div", {
                className: s['radio-button-content']
            }, /*#__PURE__*/ React.createElement("div", {
                className: ratio.prefixClassName,
                "aria-hidden": true
            }), /*#__PURE__*/ React.createElement("div", null, t(ratio.label)))))))
    });
};
AspectRatioRadioField.displayName = 'AspectRatioRadioField';
export default AspectRatioRadioField;

//# sourceMappingURL=AspectRatioRadioField.js.map